import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Car, ArrowRight } from "lucide-react";

export const NoVehicle = ({ tkey = "novehicle.pickStart" }) => {
  const { t } = useTranslation();
  return (
  <div data-testid="no-vehicle-prompt"
    className="max-w-md mx-auto my-16 rounded-2xl bg-surface border border-steel p-8 text-center animate-rise">
    <div className="w-14 h-14 mx-auto rounded-2xl bg-elevated border border-steel flex items-center justify-center text-cyan">
      <Car size={26} />
    </div>
    <h2 className="font-heading font-bold uppercase tracking-widest text-lg mt-5">{t(tkey)}</h2>
    <p className="text-slate-400 text-sm mt-2">{t("novehicle.body")}</p>
    <Link to="/garage" data-testid="no-vehicle-go-garage"
      className="inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-cyan to-blue-600 text-ink px-5 py-3 font-heading font-bold text-sm tracking-wide shadow-lg shadow-cyan/25 mt-6">
      {t("novehicle.open")} <ArrowRight size={15} />
    </Link>
  </div>
  );
};
